import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <section className="py-32 relative bg-navy-900 overflow-hidden" data-id="element-43">
      {/* Dramatic lighting effect */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-gold-500/10 blur-[120px] pointer-events-none rounded-full" data-id="element-44" />

      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center relative z-10" data-id="element-45">
        <FadeIn data-id="element-46">
          <h2 className="text-5xl md:text-7xl font-bold mb-8 font-serif" data-id="element-47">
            Toma el mapa. <br data-id="element-48" />
            <span className="text-gradient-gold" data-id="element-49">Toma el Código.</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-50">
          <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto font-light" data-id="element-51">
            No dejes que pase otro año siendo solo un espectador. El sistema
            está diseñado para mantenerte abajo, pero hoy tienes la llave para
            salir.
          </p>
        </FadeIn>

        <div id="precio" className="scroll-mt-24" data-id="element-52" />
        <FadeIn delay={0.3} className="flex flex-col items-center gap-6" data-id="element-53">
          {/* Price block */}
          <div className="flex flex-col items-center gap-2 mb-2" data-id="element-54">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-gold-500/10 border border-gold-500/30 text-gold-400 text-xs font-semibold tracking-widest uppercase" data-id="element-55">
              Oferta de Lanzamiento
            </div>
            <div className="flex items-baseline gap-4 mt-2" data-id="element-56">
              <span className="text-2xl text-gray-500 line-through font-serif" data-id="element-57">
                $47
              </span>
              <span className="text-6xl md:text-7xl font-bold text-gradient-gold font-serif" data-id="element-58">
                $6.39
              </span>
            </div>
            <p className="text-sm text-gray-400" data-id="element-59">
              Pago único · Acceso de por vida
            </p>
          </div>

          <Button className="text-lg px-12 py-5 w-full sm:w-auto" onClick={() => window.location.href = 'https://caminoexpansivo.com/cart/45074183585999:1'} data-id="element-60">
            Quiero El Código Ahora
          </Button>
          <div className="flex items-center gap-4 text-sm text-gray-500" data-id="element-61">
            <span data-id="element-62">✓ Acceso Inmediato</span>
            <span data-id="element-63">•</span>
            <span data-id="element-64">✓ Garantía de Satisfacción</span>
          </div>
        </FadeIn>
      </div>
    </section>;
}